import { IconProps } from "./";
import Icon from "./assets/chat_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Chat(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
